document.addEventListener('DOMContentLoaded', () => {
  const termsBg = document.querySelector('.terms-bg');
  const gliter = document.querySelector('.c-terms-bg-gliter');
  const swiperBefore = document.querySelector('.page-about .aboutSwiper');
  const introContainer = document.querySelector('.project-detail__introduction .c-container');
  const detailBg = document.querySelector('.project-detail__bg');
  const sectionWrapper = document.querySelector('.about .section-wrapper');
  const guzou = document.querySelector('.c-section#guzou');
  const cheer = document.querySelector('.c-section#cheer');
  const news = document.querySelector('.c-section#news');
  const faq = document.querySelector('.c-section#faq');

  if (!termsBg && !gliter && !swiperBefore && !introContainer && !detailBg && !sectionWrapper && !guzou && !cheer && !news && !faq) return;

  // Clamp helper — limits how far parallax can move from the CSS baseline
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  // Parallax: only adds a small DELTA on top of the CSS-defined baseline position
  // speed: how much it moves (keep low, e.g. 0.05–0.15)
  // clampRange: max px it can shift from center (prevents extreme positions)
  const parallax = (el, varName, speed = 0.08, clampRange = 40) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (inView) {
      // Delta from element center to viewport center — content-amount independent
      const delta = (window.innerHeight / 2 - (rect.top + rect.height / 2)) * speed;
      const offset = clamp(delta, -clampRange, clampRange);
      el.style.setProperty(varName, `${offset}px`);
    }
  };

  const onScroll = () => {
    const scrollY = window.scrollY;

    parallax(termsBg,        '--parallax-y',                  0.15, 80);
    parallax(swiperBefore,   '--swiper-parallax-y',           0.15, 80);
    parallax(introContainer, '--intro-parallax-y',            0.15, 80);
    parallax(introContainer, '--intro-after-parallax-y',      0.12, 60);
    parallax(detailBg,       '--bg-parallax-y',               0.15, 80);
    parallax(detailBg,       '--detail-bg-before-parallax-y', 0.12, 60);
    parallax(sectionWrapper, '--wrapper-parallax-y',          0.15, 80);
    parallax(sectionWrapper, '--wrapper-after-parallax-y',    0.12, 60);
    parallax(guzou,          '--guzou-parallax-y',            0.15, 80);
    parallax(guzou,          '--guzou-after-parallax-y',      0.12, 60);
    parallax(cheer,          '--cheer-after-parallax-y',      0.12, 60);
    parallax(news,           '--news-parallax-y',             0.15, 80);
    parallax(faq,            '--faq-after-parallax-y',        0.12, 60);

    if (gliter) {
      const rect = gliter.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        const delta = (window.innerHeight / 2 - (rect.top + rect.height / 2)) * 0.08;
        const offset = clamp(delta, -40, 40);
        gliter.style.transform = `translateY(${offset}px)`;
      }
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // Re-run on resize so layout changes (e.g. font load, dynamic content) self-correct
  const resizeObserver = new ResizeObserver(() => {
    onScroll();
  });
  resizeObserver.observe(document.body);

  // Fire once on load for correct initial state
  onScroll();
});